
function ToggleResultItem(element)
{
    const parent = element.closest('.multi-select') as HTMLDivElement;
    if (parent !== undefined)
    {
        const resultItem = parent.querySelector(`.multi-select__drop-item[data-id="${element.dataset.id}"]`) as HTMLLIElement;
        if (resultItem !== undefined) {
            resultItem.classList.toggle('multi-select__drop-item--selected');
        }
    }
}

function ToggleDrop(event: Event)
{
    const eventElement = event.currentTarget as HTMLElement;
    
    const nearestDrop = eventElement.closest('.multi-select')?.querySelector('.multi-select__drop') as HTMLInputElement;
    if (nearestDrop) {
        nearestDrop.classList.toggle('multi-select__drop--open');
    }
}

function CreateItem(id: string, innerHtml: string)
{
    const newElement = document.createElement('li');
    newElement.classList.add("multi-select__item", "multi-select__item--selected");
    newElement.dataset.id = id;
    newElement.innerHTML = innerHtml;

    const newRemoveElement = document.createElement('a');
    newRemoveElement.classList.add("multi-select__item-remove", "color--secondary");    
    newRemoveElement.innerHTML = '<i class="material-icons mdi mdi-close-outline cursor--pointer"></i>';
    newRemoveElement.addEventListener('click', RemoveItem);

    newElement.appendChild(newRemoveElement);

    return newElement;
}

function UpdateHiddenField(element)
{
    const mainElement = element.closest('.multi-select') as HTMLDivElement;
    const hiddenField = mainElement.querySelector('.multi-select-hidden') as HTMLInputElement;

    const selectedSectors = mainElement.querySelectorAll('.multi-select__item') as NodeListOf<HTMLLIElement>;
    let sectors: string[] = [];
    selectedSectors.forEach(item => {
        sectors.push(item.dataset.id ?? "");
    });

    hiddenField.value = sectors.join(',');
}

function AddItem(itemElement: HTMLLIElement)
{
    if (itemElement.classList.contains('multi-select__drop-item--selected')) {
        return;
    }

    const parent = itemElement.closest('.multi-select') as HTMLDivElement;
    const element = parent.querySelector('.multi-select__items') as HTMLUListElement;

    const newElement = CreateItem(itemElement.dataset.id ?? "", itemElement.innerHTML ?? "");
    element.insertBefore(newElement, element.firstChild);

    ToggleResultItem(itemElement);
    UpdateHiddenField(itemElement);
}

function RemoveItem(event: Event)
{
    const itemElement = (event.currentTarget as HTMLAnchorElement).parentElement as HTMLLIElement;
    const itemsParent = itemElement.parentElement;

    ToggleResultItem(itemElement);
    
    if (itemElement !== undefined) {
        itemElement.remove();
    }

    UpdateHiddenField(itemsParent);
}

function filterList(text: string)
{
    var elements = document.querySelectorAll('.multi-select__drop-item') as NodeListOf<HTMLInputElement>;

    elements.forEach((element) => {
        if (text.length > 0) {
            if (element.innerHTML.toLowerCase().indexOf(text.toLowerCase()) == -1) {
                element.hidden = true;
            }
            else {
                element.hidden = false;
            }
        }
        else {
            element.hidden = false;
        }
    });
}

function GroupSelect(element: HTMLLIElement)
{
    document.querySelectorAll(`.multi-select__drop-item[data-group="${element.dataset.id}"]`)
        ?.forEach((item: HTMLLIElement) => {
            AddItem(item);
        });
}

export function InitialiseMultiSelect(document)
{
    document.querySelectorAll('.multi-select__drop-item')?.forEach(item => item.addEventListener('click', (event: Event) => AddItem(event?.currentTarget as HTMLLIElement)));
    document.querySelectorAll('.multi-select__item .multi-select__item-remove')?.forEach(item => item.addEventListener('click', RemoveItem));
    document.querySelectorAll('.multi-select__drop-group')?.forEach(item => item.addEventListener('click', (event: Event) => GroupSelect(event?.currentTarget as HTMLLIElement)));
    document.querySelectorAll('.multi-select__search-input')?.forEach(item => item.addEventListener('click', ToggleDrop));

    document.querySelectorAll('.multi-select__search-input')?.forEach(item => {
        item.addEventListener("keyup", (event: Event) => {
            const element = event.currentTarget as HTMLInputElement;
            filterList(element.value);
        })
    });

    window.addEventListener("mouseup", (event) => {
        const container = document.querySelectorAll('.multi-select__drop');
        if (container !== null) {
            container.forEach(item => {
                const eventElement = event.target as HTMLElement;
                const nearestInput = eventElement.closest('.multi-select')?.querySelector('.multi-select__search-input') as HTMLInputElement;

                if (eventElement !== null && (eventElement.closest('.multi-select__drop') === null && eventElement !== nearestInput )) {
                    item.classList.remove('multi-select__drop--open');
                }
            })
        }
    })
}